let mobileNavLoaded = false

class MobileNavigation extends window.BAO.CustomElement() {
  connectedCallback() {
    super.setupListeners()
    this.initialise()
  }

  initialise() {

    if (mobileNavLoaded) return

    window.BAO.sectionRenderer
      .fetch('drawers', '/?view=mobile-navigation')
      .then(res => {
        mobileNavLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.drawers)
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {
      })
  }
}

if (!customElements.get('mobile-navigation')) {
  customElements.define('mobile-navigation', MobileNavigation)
}
